import { getAppInsights } from "../../utils/application-insights/applicationInsights";
import tryParseInt from "../../utils/tryParseInt";

export const PageView = () => {
  const appInsights = getAppInsights();
  if (appInsights) {
    appInsights.trackPageView({ uri: window.location.pathname + window.location.search });
  }
};

export const Event = (category, action, label, value) => {
  const appInsights = getAppInsights();
  if (!appInsights) return;

  const properties = { category, action, label };

  if (tryParseInt(value)) {
    properties.value = String(Math.round(Number(value)));
  }

  appInsights.trackEvent({ name: category, properties });
};
